//#region src/components/file-types/file-type-helper.ts
var e = class e {
	static extensions = {
		rtf: "doc",
		odt: "doc",
		xlsm: "xls",
		ods: "xls",
		tsv: "csv",
		key: "ppt",
		md: "txt",
		log: "txt",
		html: "xml",
		rar: "zip",
		"7z": "zip",
		tar: "zip",
		gz: "zip",
		pdf: "pdf",
		doc: "doc",
		docx: "doc",
		xls: "xls",
		xlsx: "xls",
		csv: "csv",
		ppt: "ppt",
		pptx: "ppt",
		txt: "txt",
		png: "image",
		jpg: "image",
		jpeg: "image",
		gif: "image",
		svg: "image",
		webp: "image",
		heic: "image",
		json: "json",
		xml: "xml",
		zip: "zip"
	};
	static fromFilename(t) {
		let n = t.trim().split(/[\\/]/).at(-1) ?? "", r = n.lastIndexOf(".");
		if (r <= 0) return "generic";
		let i = n.slice(r + 1).toLowerCase();
		return Object.hasOwn(e.extensions, i) ? e.extensions[i] : "generic";
	}
};
//#endregion
export { e as FileTypeHelper };
